module.exports = __webpack_public_path__ + "img/12mi.d09f4d4c.png";